'use client'

import { useEffect, useState } from 'react'

/**
 * Returns the bottom offset in px so a fixed bottom element stays above the virtual keyboard.
 * When the keyboard is closed, returns 0. When open, returns the height of the area hidden by the keyboard
 * (layout viewport bottom minus visual viewport bottom).
 */
export function useVisualViewportBottomOffset(): number {
    const [offset, setOffset] = useState(0)

    useEffect(() => {
        if (typeof window === 'undefined' || !window.visualViewport) return

        const update = () => {
            const vv = window.visualViewport

            if (!vv) return

            const bottomOfVisual = vv.offsetTop + vv.height
            const layoutHeight = window.innerHeight
            setOffset(Math.max(0, layoutHeight - bottomOfVisual))
        }

        update()
        window.visualViewport.addEventListener('resize', update)
        window.visualViewport.addEventListener('scroll', update)

        return () => {
            if (!window.visualViewport) return

            window.visualViewport.removeEventListener('resize', update)
            window.visualViewport.removeEventListener('scroll', update)
        }
    }, [])

    return offset
}
